import { STUDENT_COURSE_VALIDATION } from '../../api/endpoints';
import request from '../../api/request';
import {
  CourseValidationInternalBase,
  CourseValidationInternalStudents,
  CourseValidationInternalStudentsQuery,
  GetFormDataResponse,
} from './types';

export function getCourseValidationInternal() {
  return request<CourseValidationInternalBase>(
    STUDENT_COURSE_VALIDATION.INTERNAL.BASE,
    {
      method: 'get',
    },
  );
}

export function getCourseValidationInternalStudents(
  query: CourseValidationInternalStudentsQuery,
) {
  return request<CourseValidationInternalStudents>(
    STUDENT_COURSE_VALIDATION.INTERNAL.STUDENTS,
    {
      method: 'get',
      params: {
        studyPlanVersionId: query.search.studyPlanVersionId,
        searchText: query.search.searchText,
        periodId: query.search.periodId,
        campusId: query.search.campusId,
        page: query.page - 1,
      },
    },
  );
}

export function getCourseValidationInternalForm() {
  const url = STUDENT_COURSE_VALIDATION.INTERNAL.FORM;
  return request<GetFormDataResponse>(url, {
    method: 'get',
  });
}
